import { Component, Input } from '@angular/core';

@Component({
  selector: 'liberro-spinner',
  standalone: false,
  templateUrl: './liberro-spinner.component.html',
  styleUrl: './liberro-spinner.component.less'
})
export class LiberroSpinnerComponent {

  @Input({ required: true }) public show = false;
  @Input() public type: 'overlay' | 'attach' | 'inline' = 'overlay';
  @Input() public customBg = '';

}

